module.exports = __webpack_public_path__ + "img/317-6b58e2.png";